import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

class AssetsDepreciationFail extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  };

  render = () => (
    <div className="col-12 bbottom mb-3 mt-3">
      <div className="alert alert-info text-center">
        <h5>
          {this.props.t('error.depreciation_fails')} {this.props.t(this.props.title)}
        </h5>
      </div>
    </div>
  );
}

export default translate()(AssetsDepreciationFail);



// WEBPACK FOOTER //
// src/components/assets/depreciation/AssetsDepreciationFail.js